/**
 * Compare a work order's estimated duration against the already-allocated
 * mechanic window. Hour edits must not silently stretch that slot (#1441).
 */

export function allocatedSlotHours(opts: {
  mechanicScheduledStart: string | null | undefined;
  mechanicScheduledEnd: string | null | undefined;
}): number | null {
  if (!opts.mechanicScheduledStart || !opts.mechanicScheduledEnd) return null;
  const start = new Date(opts.mechanicScheduledStart).getTime();
  const end = new Date(opts.mechanicScheduledEnd).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return null;
  return Number(((end - start) / 3_600_000).toFixed(2));
}

export function durationExceedsAllocatedSlot(
  durationHours: number,
  slotHours: number | null | undefined,
): boolean {
  if (slotHours == null || !Number.isFinite(slotHours) || slotHours <= 0) return false;
  if (!Number.isFinite(durationHours)) return false;
  return Math.round(durationHours * 100) > Math.round(slotHours * 100);
}
